import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import Reveal from "../Reveal";
import { useContent } from "../../context/ContentContext";
import { mediaUrl } from "../../api";

export default function GlobalReach() {
  const { content } = useContent();
  const regions = content.regions || [];
  const images = content.images || {};
  return (
    <section className="relative py-20 lg:py-28 bg-[#06111d] text-white overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-25">
        <img src={mediaUrl(images.containersSunset)} alt="" className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#06111d] via-[#06111d]/85 to-[#06111d]/40" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] text-[#7fc6d6] font-medium">Global reach</p>
            <h2 className="mt-3 font-display text-[34px] lg:text-[46px] leading-[1.08] text-white">
              Serving healthcare worldwide
            </h2>
            <p className="mt-5 text-[16px] leading-relaxed text-white/70 max-w-lg">
              Proudly serving pharmaceutical companies across the Middle East, Africa, North Africa,
              Latin America, Asia, CIS Countries, Europe, the Balkans and the US.
            </p>
          </Reveal>
          <Reveal delay={120}>
            <Link
              to="/global-presence"
              className="mt-8 inline-flex items-center gap-2 bg-card text-[#2ED9B8] rounded-full px-6 h-12 font-medium hover:bg-[#0f2236] transition-colors"
            >
              Explore countries we serve <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {regions.map((r, i) => (
            <Reveal key={r} delay={(i % 3) * 70}>
              <div className="rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm px-4 py-4 hover:bg-white/10 transition-colors">
                <MapPin className="h-4 w-4 text-[#7fc6d6]" />
                <p className="mt-2.5 text-sm font-medium text-white">{r}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
